import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Container, Stack, Typography } from "@mui/material";
import { TitleComponents } from "../titleComponent/TitleComponents.js";
import Footer from "./Footer.js";
import GalleryDetailSlide from "./GalleryDetailSlide.js";
import NewsDetailBtn from "../elements/NewsDetailBtn.js";
import ScrollToTop from "../elements/ScrollToTop";
import ContainerLayout from "./ContainerLayout";

export default function GalleryDetailList({ isNews = false, brand, info }) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    const brandColor =
        brand === "littleband" ? "littleBand.main" : brand === "littleartists" ? "littleArtist.main" : "primary.main";

    // 최초 진입 시 스크롤 최상단으로 이동
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Stack>
            <ContainerLayout
                sx={{
                    position: "fixed",
                    top: 0,
                    width: "100%",
                    textAlign: "center",
                    py: 3,
                    borderBottom: "1px solid",
                    borderColor: "constant.gray",
                }}>
                <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
                    {/* 버튼 */}
                    <NewsDetailBtn onClick={() => navigate(-1)} />
                    {/* title */}
                    <TitleComponents>
                        <TitleComponents.Subtitle typoStyle={{ color: brandColor }}>
                            {isNews ? "소식&뉴스" : "갤러리"}
                        </TitleComponents.Subtitle>
                    </TitleComponents>
                    <Stack sx={{ width: 40 }} />
                </Stack>
            </ContainerLayout>
            <Container maxWidth="xl" sx={{ mt: 11, pl: { xs: 0 }, pr: { xs: 0 } }}>
                <Stack alignItems="center" sx={{ p: "29px 16px 20px" }}>
                    {/* 뉴스 헤더 */}
                    <Stack
                        justifyContent="center"
                        alignItems="center"
                        sx={{ width: "100%", height: "109px", bgcolor: "#f5f5f5", p: "16px 47px 16px 16px" }}>
                        <TitleComponents>
                            <TitleComponents.MainTitle
                                typoStyle={{
                                    color: "black",
                                    fontSize: "18px",
                                    letterSpacing: "-0.14px",
                                    lineHeight: "1.56",
                                }}>
                                {info.title}
                            </TitleComponents.MainTitle>
                        </TitleComponents>
                    </Stack>
                    <Stack
                        flexDirection="row"
                        justifyContent="space-between"
                        sx={{
                            width: "100%",
                            p: "8.8px 0",
                            color: "#a0a0a0",
                            borderBottom: "1px solid",
                            borderColor: "constant.gray",
                        }}>
                        <Typography>{isNews ? info.type : "갤러리"}</Typography>
                        <Typography>{info.date}</Typography>
                    </Stack>
                </Stack>
                {/* 뉴스 or 갤러리 컨텐츠 */}
                {info?.des?.length > 0 && (
                    <Stack alignItems="center" spacing={4} sx={{ height: "100%", width: "100%", mb: 20 }}>
                        {info.des.map((co, index) => (
                            <Stack key={index} alignItems="center" sx={{ width: "100%" }}>
                                {co && (
                                    <Stack
                                        maxWidth="md"
                                        sx={{ mx: 1 }}
                                        onClick={() => {
                                            setOpen(true);
                                            setIndex(index);
                                        }}>
                                        <img src={co} alt={co} style={{ borderRadius: "18px" }} />
                                    </Stack>
                                )}
                            </Stack>
                        ))}
                    </Stack>
                )}
            </Container>
            <Footer />
            <GalleryDetailSlide open={open} setOpen={setOpen} info={info} index={index} setIndex={setIndex} />
            <ScrollToTop />
        </Stack>
    );
}
